import {Component, OnInit, input} from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent implements OnInit {
  private static readonly DEFAULT_ICON_SIZE = 24;

  readonly icon = input('icon-placeholder');
  readonly size = input<'xs' | 'sm' | 'md' | 'lg'>('sm');
  readonly color = input<'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'danger' | 'dark' | 'white'>(
    'primary'
  );
  readonly customStyleClass = input('');

  iconSize: number | null = null;
  iconSrc: string | null = null;
  iconColor: string | null = null;

  ngOnInit(): void {
    this.iconSize = this.getIconSize(this.size());
    this.iconSrc = this.getIconSrc(this.icon());
    this.iconColor = this.getIconColor(this.color());
  }

  getIconSize(size: string): number {
    switch (size) {
      case 'xs':
        return 0.5 * IconComponent.DEFAULT_ICON_SIZE;
      case 'sm':
        return 1 * IconComponent.DEFAULT_ICON_SIZE;
      case 'md':
        return 2 * IconComponent.DEFAULT_ICON_SIZE;
      case 'lg':
        return 3 * IconComponent.DEFAULT_ICON_SIZE;
      default:
        return IconComponent.DEFAULT_ICON_SIZE;
    }
  }

  getIconSrc(icon: string): string {
    return `assets/icons/${icon}.svg`;
  }

  getIconColor(color: string): string {
    switch (color) {
      case 'primary':
        return 'icon-primary';
      case 'secondary':
        return 'icon-secondary';
      case 'accent':
        return 'icon-accent';
      case 'success':
        return 'icon-success';
      case 'warning':
        return 'icon-warning';
      case 'danger':
        return 'icon-danger';
      case 'dark':
        return 'icon-dark';
      case 'white':
        return 'icon-white';
      default:
        return 'icon-primary';
    }
  }
}
